import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/shared/utils';

type DetailSectionHeaderProps = {
  title: string;
  icon?: LucideIcon;
  action?: ReactNode;
  showDivider?: boolean;
  className?: string;
};

export function DetailSectionHeader({
  title,
  icon: Icon,
  action,
  showDivider = true,
  className,
}: DetailSectionHeaderProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-3 mb-4',
        showDivider ? undefined : 'justify-between',
        className
      )}
    >
      <div className="flex items-center gap-2 min-w-0">
        {Icon && <Icon className="size-4 text-muted-foreground shrink-0" />}
        <h4 className="text-sm font-semibold text-foreground truncate">{title}</h4>
      </div>
      {showDivider && <div className="h-px flex-1 bg-border" />}
      {action}
    </div>
  );
}
